import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';

const ActivityVisibilityContent = ({ selectedOption, onVisibilityChange }) => {
  const { t } = useTranslation('settings');

  const options = [
    {
      id: 'everyone',
      label: t('pages.privacy.activityVisibility.options.everyone'),
      description: t('pages.privacy.activityVisibility.options.everyoneDescription')
    },
    {
      id: 'followers',
      label: t('pages.privacy.activityVisibility.options.friends'),
      description: t('pages.privacy.activityVisibility.options.friendsDescription')
    },
    {
      id: 'nearby',
      label: t('pages.privacy.activityVisibility.options.nearby'),
      description: t('pages.privacy.activityVisibility.options.nearbyDescription')
    }
  ];

  const handleOptionChange = (optionId) => {
    onVisibilityChange(optionId);
  };

  return (
    <div className="visibility-content">
      <h2 className="visibility-title">{t('pages.privacy.activityVisibility.title')}</h2>
      <p className="preferences-section-description">
        {t('pages.privacy.activityVisibility.description')}
      </p>
      
      <div className="preferences-options-list">
        {options.map((option) => (
          <label 
            key={option.id} 
            className={`preference-radio-option ${selectedOption === option.id ? 'selected' : ''}`}
          >
            <div className="preference-radio-content">
              <div className="preference-radio-label">{option.label}</div>
              <div className="preference-radio-description">{option.description}</div>
            </div>
            <input
              type="radio"
              name="activityVisibility"
              value={option.id}
              checked={selectedOption === option.id}
              onChange={() => handleOptionChange(option.id)}
              className="preference-radio-input"
            />
            <span className="preference-radio-custom"></span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ActivityVisibilityContent; 